import React from 'react'
import { buildFileUrl } from '../../config/strapi'
import { SecondCard as SecondCardType } from '../../types/strapi'

interface SecondCardProps {
  card: SecondCardType
}

export function SecondCard({ card }: SecondCardProps) {
  if (!card) return null

  const headers = card.Header || []
  const image = card.image?.url ? buildFileUrl(card.image.url) : undefined

  return (
    <section
      style={{
        width: '100%',
        background: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 'clamp(10px, 1vw, 5px) 0 clamp(5px, 1vw, 100px) 0',
        minHeight: 600,
        boxSizing: 'border-box',
        position: 'relative',
        overflow: 'hidden',
        fontFamily: 'Poppins, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
      }}
    >
      {/* Container flex responsivo */}
      <div
        className="second-card-content"
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
          maxWidth: 1480,
          minHeight: 440,
          position: 'relative',
          zIndex: 2,
          gap: '60px',
          padding: '0 40px',
        }}
      >
        <div style={{ 
          flex: 1, 
          minWidth: 320, 
          display: 'flex', 
          flexDirection: 'column', 
          justifyContent: 'center', 
          height: 520,
          maxWidth: '40%'
        }}>
          {/* Renderiza múltiplos headers */}
          {headers.map((header, index: number) => (
            <div key={index} style={{
              marginBottom: index < headers.length - 1 ? '32px' : '0'
            }}>
              <h2 style={{
                fontSize: 36,
                fontWeight: 700,
                marginBottom: 16,
                color: '#111',
                lineHeight: 1.15,
                textAlign: 'left',
                maxWidth: 600,
                letterSpacing: 1,
              }}>
                {header?.title}
              </h2>
              <p style={{
                fontSize: 20,
                color: '#222',
                lineHeight: 1.5,
                textAlign: 'left',
                maxWidth: 600,
                letterSpacing: 1,
              }}>
                {header?.subtitle}
              </p>
            </div>
          ))}
        </div>
        
        {/* Imagem responsiva junto ao texto */}
        {image && (
          <div style={{
            flex: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            maxWidth: '60%',
            minWidth: 500,
          }}>
            <img
              src={image}
              alt={headers[0]?.title || 'Imagem demonstrativa'}
              style={{
                width: '100%',
                maxWidth: 1000,
                height: 'auto',
                objectFit: 'contain',
                transition: 'all 0.3s',
                display: 'block',
              }}
              className="second-card-image-responsive"
            />
          </div>
        )}
      </div>
      
      <style>{`
        @media (max-width: 1024px) {
          .second-card-content {
            flex-direction: column !important;
            align-items: center !important;
            justify-content: center !important;
            min-height: 0 !important;
            gap: 40px !important;
            padding: 0 20px !important;
          }
          .second-card-content > div:first-child {
            max-width: 100% !important;
            text-align: center !important;
            align-items: center !important;
          }
          .second-card-content > div:first-child h2 {
            text-align: center !important;
          }
          .second-card-content > div:first-child p {
            text-align: center !important;
          }
          .second-card-content > div:last-child {
            max-width: 90% !important;
            min-width: 400px !important;
          }
          .second-card-image-responsive {
            width: 100% !important;
            max-width: 750px !important;
            height: auto !important;
          }
        }
        @media (max-width: 600px) {
          .second-card-content {
            flex-direction: column !important;
            align-items: center !important;
            gap: 32px !important;
            padding: 0 16px !important;
          }
          .second-card-content > div:first-child {
            text-align: center !important;
            padding: 0 !important;
            align-items: center !important;
            max-width: 100% !important;
          }
          .second-card-content > div:first-child h2 {
            text-align: center !important;
            font-size: 28px !important;
          }
          .second-card-content > div:first-child p {
            text-align: center !important;
            font-size: 18px !important;
          }
          .second-card-content > div:last-child {
            max-width: 100% !important;
            min-width: 0 !important;
          }
          .second-card-image-responsive {
            width: 100% !important;
            max-width: 100% !important;
            margin: 0 !important;
          }
        }
      `}</style>
    </section>
  )
} 